import React, { FC } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';

interface WrapTextToggleProps {
    isEnabled: boolean;
    onChange: (enabled: boolean) => void;
}

const WrapTextToggle: FC<WrapTextToggleProps> = ({ isEnabled, onChange }) => {
    return (
        <ToggleButton
            $isEnabled={isEnabled}
            onClick={() => onChange(!isEnabled)}
            aria-label="Wrap text in table"
            aria-pressed={isEnabled}
        >
            Wrap Text
            <MiniSwitch $isEnabled={isEnabled}>
                <MiniThumb $isEnabled={isEnabled} />
            </MiniSwitch>
        </ToggleButton>
    );
};

const ToggleButton = styled.button<{ $isEnabled: boolean }>(
    ({ $isEnabled }) => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        height: '28px',
        padding: aampeTheme.spacing4(0, 1.5),
        fontSize: aampeTheme.size.font.textSmall,
        fontWeight: aampeTheme.weights.light,
        lineHeight: aampeTheme.size.lineHeight.default,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        borderRadius: aampeTheme.borderRadius.default,
        border: `1px solid ${
            $isEnabled
                ? aampeTheme.colors.solidA01
                : aampeTheme.colors.bordersWG01
        }`,
        backgroundColor: $isEnabled
            ? aampeTheme.colors.interactiveA01
            : aampeTheme.colors.white,
        color: $isEnabled
            ? aampeTheme.colors.solidA01
            : aampeTheme.colors.textAccessibleWG01,
        userSelect: 'none',
        transition: 'border-color 0.15s, background-color 0.15s, color 0.15s',
        '&:hover': {
            borderColor: aampeTheme.colors.solidA01,
            color: aampeTheme.colors.solidA01,
            backgroundColor: aampeTheme.colors.interactiveA01,
        },
    }),
);

const MiniSwitch = styled.span<{ $isEnabled: boolean }>(({ $isEnabled }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    width: '24px',
    height: '14px',
    borderRadius: '7px',
    backgroundColor: $isEnabled
        ? aampeTheme.colors.solidA01
        : aampeTheme.colors.bordersWG03,
    transition: 'background-color 0.15s',
    flexShrink: 0,
    position: 'relative',
}));

const MiniThumb = styled.span<{ $isEnabled: boolean }>(({ $isEnabled }) => ({
    position: 'absolute',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: aampeTheme.colors.white,
    transition: 'left 0.15s',
    left: $isEnabled ? '12px' : '2px',
    top: '2px',
}));

export default WrapTextToggle;
